import appConfig from '@/features/app/constants/app-config';
import captureSentryException from '@/features/app/functions/captureSentryException';
import staleQueryIfNotError from '@/features/app/functions/staleQueryIfNotError';
import { AdminSettings } from '@/features/app/types/admin-settings';
import useUnauthenticatedAxios from '@/shared/hooks/useAuthenticatedAxios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export default function useAdminSettingsQuery(
  options: Omit<UseQueryOptions<AdminSettings>, 'queryKey'> = {}
) {
  const { i18n } = useTranslation();
  const axios = useUnauthenticatedAxios();

  return useQuery<AdminSettings>({
    queryKey: ['adminSetting', i18n.language],
    queryFn: async () => {
      return axios
        .get(`/api/v1/admin-settings`)
        .then((res) => {
          return {
            ...res.data.adminSettings[0],
            upcomingMaintenance: null,
          } satisfies AdminSettings;
        })
        .catch((err) => {
          captureSentryException(err);
          return Promise.reject(err);
        });
    },
    placeholderData: {
      logoLightVariant: {
        fullpath: '',
      },
      logoDarkVariant: {
        fullpath: '',
      },
      defaultProductImage: {
        fullpath: '',
      },
      videoLink: null,
      upcomingMaintenance: null,
    } satisfies AdminSettings,
    ...staleQueryIfNotError(appConfig.defaultLongDataStaleTime),
    ...options,
  });
}
